import API from 'services/API';

export default function getTemporaryBannerStatus() {
  return API.request({
    method: 'GET',
    url: `/banner/techWork`,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    cancelToken: true,
  });
}
